import React, { Component } from "react";

// Importing Section
import Navbar from "../../component/Navbar/NavBar";
import AboutUs from "../../sections/home/AboutUs";
import BannerVideo from "../../sections/home/BannerVideo";
import CommercialSolution from "../../sections/home/CommercialSolution";
import HomeSolution from "../../sections/home/HomeSolution";
import WhyUs from "../../sections/home/WhyUs";
import ContactUs from "../../sections/home/ContactUs";

class Layout1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navItems: [
        { id: 1, idnm: "home", navheading: "Home" },
        { id: 2, idnm: "why-us", navheading: "Why Us" },
        { id: 3, idnm: "home-solution", navheading: "Home Solution" },
        {
          id: 4,
          idnm: "commercial-solution",
          navheading: "Commercial Solution",
        },
        // { id: 5, idnm: "what-our-customers-say", navheading: "Clients" },
        // { id: 6, idnm: "goverment-scheme", navheading: "Schemes" },
        // { id: 7, idnm: "our-teams", navheading: "Our Teams" },
        { id: 8, idnm: "about-us", navheading: "About Us" },
      ],
      pos: document.documentElement.scrollTop,
      imglight: false,
      navClass: "",
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.scrollNavigation, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    var scrollup = document.documentElement.scrollTop;
    if (scrollup > this.state.pos) {
      this.setState({ navClass: "nav-sticky", imglight: false });
    } else {
      this.setState({ navClass: "", imglight: false });
    }
  };

  render() {
    return (
      <>
        {/* Importing Navbar */}
        <Navbar
          navItems={this.state.navItems}
          navClass={this.state.navClass}
          imglight={this.state.imglight}
        />

        {/* 1. Importing Video Section */}
        <BannerVideo />

        {/* 2. Why Us */}
        <WhyUs />

        {/* 3. Home Solution */}
        <HomeSolution />

        {/* 4. Commercial Solution */}
        <CommercialSolution />

        {/* 7. About Us */}
        <AboutUs />

        {/* 8. Contact Us */}
        <ContactUs />

        {/* 8. Our Teams */}
        {/* <OurTeams /> */}

        {/* Importing Section */}
        {/* <Section /> */}

        {/* Importing About */}
        {/* <About /> */}

        {/* Importing Service */}
        {/* <Services /> */}

        {/* Importing Feature */}
        {/* <Feature /> */}

        {/* Importing Project */}
        {/* <Project /> */}

        {/* Importing Client */}
        {/* <Clients /> */}

        {/* Importing News */}
        {/* <News /> */}

        {/* Importing Contact Us */}
        {/* <Contact /> */}

        {/* Importing Footer */}
        {/* <Footer /> */}
      </>
    );
  }
}

export default Layout1;

// ----------------------------------------- OLD ----------------------------------------

// import React, { Component, Suspense } from "react";

// // Importing Section
// const Navbar = React.lazy(() => import("../../component/Navbar/NavBar"));

// const Section = React.lazy(() => import("./Section"));
// const About = React.lazy(() => import("../../component/About"));
// const Services = React.lazy(() => import("../../component/Services"));
// // const Feature = React.lazy(() => import("../../component/Feature"));
// const Project = React.lazy(() => import("../../component/Project"));
// const Clients = React.lazy(() => import("../../component/Clients"));
// // const News = React.lazy(() => import("../../component/News"));
// const Contact = React.lazy(() => import("../../component/Contact"));
// const Footer = React.lazy(() => import("../../component/Footer/Footer"));

// class Layout1 extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       navItems: [
//         { id: 1, idnm: "home", navheading: "Home" },
//         { id: 2, idnm: "about", navheading: "About Us" },
//         { id: 3, idnm: "services", navheading: "Services" },
//         // { id: 4, idnm: "features", navheading: "Features" },
//         { id: 5, idnm: "project", navheading: "Project" },
//         { id: 6, idnm: "clients", navheading: "Clients" },
//         { id: 7, idnm: "contact", navheading: "Contact Us" },
//       ],
//       pos: document.documentElement.scrollTop,
//       imglight: false,
//       navClass: "",
//     };
//   }

//   componentDidMount() {
//     window.addEventListener("scroll", this.scrollNavigation, true);
//   }

//   componentWillUnmount() {
//     window.removeEventListener("scroll", this.scrollNavigation, true);
//   }

//   scrollNavigation = () => {
//     var scrollup = document.documentElement.scrollTop;
//     if (scrollup > this.state.pos) {
//       this.setState({ navClass: "nav-sticky", imglight: false });
//     } else {
//       this.setState({ navClass: "", imglight: false });
//     }
//   };

//   //set preloader div
//   PreLoader = () => {
//     return (
//       <div id="preloader">
//         <div id="status">
//           <div className="spinner">
//             <div className="bounce1"></div>
//             <div className="bounce2"></div>
//             <div className="bounce3"></div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   render() {
//     return (
//       <React.Fragment>
//         <Suspense fallback={this.PreLoader()}>
//           {/* Importing Navbar */}
//           <Navbar
//             navItems={this.state.navItems}
//             navClass={this.state.navClass}
//             imglight={this.state.imglight}
//           />

//           {/* Importing Section */}
//           <Section />

//           {/* Importing About */}
//           <About />

//           {/* Importing Service */}
//           <Services />

//           {/* Importing Feature */}
//           {/* <Feature /> */}

//           {/* Importing Project */}
//           <Project />

//           {/* Importing Client */}
//           <Clients />

//           {/* Importing News */}
//           {/* <News /> */}

//           {/* Importing Contact Us */}
//           <Contact />

//           {/* Importing Footer */}
//           <Footer />
//         </Suspense>
//       </React.Fragment>
//     );
//   }
// }
// export default Layout1;
